export const mapTransactionTypeToIcon = (status: string) => {
  if (status === 'SEND_EXTERNAL' || status === 'SWAP_SOURCE') return 'send';
  if (
    status === 'BUY' ||
    status === 'SWAP_DESTINATION' ||
    status === 'RECEIVE_EXTERNAL'
  )
    return 'receive';
  return 'help';
};

export const mapTransactionTypeToText = (status: string) => {
  if (status === 'SEND_EXTERNAL' || status === 'SWAP_SOURCE') return 'Sent';
  if (
    status === 'BUY' ||
    status === 'SWAP_DESTINATION' ||
    status === 'RECEIVE_EXTERNAL'
  )
    return 'Received';
  return (
    status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
  ).replaceAll('_', ' ');
};
